import { render, staticRenderFns } from "./DocumentSymbol.vue?vue&type=template&id=26aeca54&scoped=true&"
import script from "./DocumentSymbol.vue?vue&type=script&lang=js&"
export * from "./DocumentSymbol.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSymbol.vue?vue&type=style&index=0&id=26aeca54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aeca54",
  null
  
)

export default component.exports